import { conditionFormChecker, putField } from "../../../../utils/form";
import i18n from "../../../../i18n";
import { createFieldInput, } from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput, /*createColumnSelect*/ } from "../../../../components/table/c-table.logic";

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.ld50.nameTh"), dataIndex: "nameTh", align: "center"}),
        createColumnInput({ title: () => i18n.global.t("model.ld50.nameEn"), dataIndex: "nameEn", align: "center"}),
        createColumnInput({ title: () => i18n.global.t("model.ld50.solidDesc"), dataIndex: "solidDesc", align: "center"}),
        createColumnInput({ title: () => i18n.global.t("model.ld50.liquidDesc"), dataIndex: "liquidDesc", align: "center"}),
    ]
    return columns
}

export const createField = ({ props, data, /*key*/ }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "nameTh",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.ld50.nameTh"),
                inputProp: () => ({
                    disabled: viewOnly,
                    value: modelRef.nameTh,
                    "onUpdate:value": value => (modelRef.nameTh = value),
                })
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "nameEn",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.ld50.nameEn"),
                inputProp: () => ({
                    disabled: viewOnly,
                    value: modelRef.nameEn,
                    "onUpdate:value": value => (modelRef.nameEn = value),
                })
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "solidDesc",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.ld50.solidDesc"),
                inputProp: () => ({
                    disabled: viewOnly,
                    value: modelRef.solidDesc,
                    "onUpdate:value": value => (modelRef.solidDesc = value),
                })
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "liquidDesc",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.ld50.liquidDesc"),
                inputProp: () => ({
                    disabled: viewOnly,
                    value: modelRef.liquidDesc,
                    "onUpdate:value": value => (modelRef.liquidDesc = value),
                })
            })
        ]
    });
};